// ---- 조직 목록 컬럼 아이템 ----

interface OrgItemProps {
  name: string;
  count?: number;
  isSelected: boolean;
  isEditing: boolean;
  editValue: string;
  onSelect: () => void;
  onEditChange: (v: string) => void;
  onEditSave: () => void;
  onEditCancel: () => void;
  onEditStart: () => void;
  onDeleteRequest: () => void;
  onClickCount?: () => void;
  onViewMembers?: () => void;
  deleteMode?: boolean;
}

const OrgItem = ({
  name,
  count,
  isSelected,
  isEditing,
  editValue,
  onSelect,
  onEditChange,
  onEditSave,
  onEditCancel,
  onEditStart,
  onDeleteRequest,
  onClickCount,
  onViewMembers,
  deleteMode = false,
}: OrgItemProps) => {
  return (
    <div
      className={`group flex cursor-pointer items-center justify-between gap-1 border-b border-gray-100 px-3 py-2 transition-all duration-150 last:border-none ${
        isSelected
          ? "bg-primary text-white"
          : "hover:-translate-y-px hover:bg-blue-50/40 hover:shadow-md"
      }`}
      onClick={() => onSelect()}
    >
      {isEditing ? (
        <input
          className="flex-1 rounded-lg border border-gray-300 px-2 py-0.5 text-small text-black outline-none focus:border-primary focus:ring-1 focus:ring-primary/20"
          value={editValue}
          onChange={e => onEditChange(e.target.value)}
          onKeyDown={e => {
            if (e.key === "Enter") onEditSave();
            if (e.key === "Escape") onEditCancel();
          }}
          onClick={e => e.stopPropagation()}
          autoFocus
        />
      ) : (
        <span className="flex-1 truncate text-small">
          {name}
          {count !== undefined && (
            <span
              className={`ml-1 text-small ${isSelected ? "text-white/80" : "text-gray-dull"}`}
              onClick={e => {
                e.stopPropagation();
                onClickCount?.();
              }}
            >
              ({count}명)
            </span>
          )}
        </span>
      )}

      <div
        className={`flex shrink-0 gap-1 ${
          isEditing || isSelected ? "visible" : "invisible group-hover:visible"
        }`}
        onClick={e => e.stopPropagation()}
      >
        {isEditing ? (
          <>
            <button
              className="text-small text-green-600 hover:underline"
              onClick={onEditSave}
            >
              저장
            </button>
            <button
              className="text-small text-gray-dull hover:underline"
              onClick={onEditCancel}
            >
              취소
            </button>
          </>
        ) : (
          <>
            {onViewMembers && (
              <button
                className={`text-small hover:underline ${isSelected ? "text-white" : "text-blue-500"}`}
                onClick={onViewMembers}
              >
                인원
              </button>
            )}
            <button
              className={`text-small hover:underline ${isSelected ? "text-white" : "text-primary"}`}
              onClick={onEditStart}
            >
              편집
            </button>
            {deleteMode && (
              <button
                className={`text-small hover:underline ${isSelected ? "text-white" : "text-red-500"}`}
                onClick={onDeleteRequest}
              >
                삭제
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default OrgItem;
